<div id="no-analysis">
  @if (selectedDay?.isCloudly) {
    <div class="no-analysis cloudy">
      <span class="icon">☁️</span>
      <p class="title">{{ 'doktar_app.services.crop_monitoring.no_analysis' | translate }}!</p>
      <p class="description">
        {{ 'doktar_app.services.crop_monitoring.no_analysis_message_cloudy' | translate }}
      </p>
    </div>
  } @else {
    <div class="no-analysis error">
      <span class="icon">
        <i class="ph-fill ph-warning icon"></i>
      </span>
      <p class="title">{{ 'doktar_app.services.crop_monitoring.no_analysis' | translate }}</p>
      <p class="description">
        @if (isPreparing) {
          {{ 'doktar_app.services.crop_monitoring.analysis_preparing_message_issue' | translate }}
        } @else {
          {{ 'doktar_app.services.crop_monitoring.no_analysis_message_issue' | translate }}
        }
      </p>
    </div>
  }
</div>
